import { UserService } from './user.service'
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';


@Injectable()
export class AuthGuard  {

  constructor(private router: Router, private authService: UserService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.currentUserValue) {
      const userRole = this.authService.currentUserValue.role;
      if (route.data.role && route.data.role.indexOf(userRole) === -1) {
        this.router.navigate(["/login"]);
        return false;
      }
      return true;
    }

    this.router.navigate(["/login"]);
    return false;
  }



}